import { useSyncExternalStore } from 'react';
import { getAppSessionId, subscribe } from '../store/appSessionStore';

export function useAppSessionId(): string | null {
  return useSyncExternalStore(subscribe, getAppSessionId, getAppSessionId);
}
